// EmployerPartnerships.js
import React from 'react';
import { motion } from 'framer-motion';

const EmployerPartnerships = () => {
  const countries = [
    { name: 'United Kingdom', image: 'uk.jpg' },
    { name: 'Ireland', image: 'ireland.jpg' },
    { name: 'Canada', image: 'canada.jpg' },
    { name: 'Australia', image: 'australia.jpg' }
  ];

  return (
    <section className="py-16 bg-[#F5F8FA]">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12"
        >
          <h2 className="text-3xl md:text-4xl font-semibold text-[#202356] mb-4">
            Our Employer Partnerships
          </h2>
          <p className="text-gray-600 text-sm font-light max-w-3xl mx-auto mb-8">
            Notapaths works with established employers and recruitment partners across key destinations, including:
          </p>
        </motion.div>

        {/* Countries Grid */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.2 }}
        >
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mb-12">
            {countries.map((country, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, scale: 0.9 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4, delay: 0.3 + (index * 0.1) }}
                className="bg-white p-6 text-center hover:shadow-md transition-all border border-gray-200"
              >
                <div className="w-12 h-12 mx-auto mb-3 rounded-full overflow-hidden shadow-md">
                  <img 
                    src={require(`../../assets/countries/${country.image}`)} 
                    alt={country.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="text-sm font-normal text-gray-700">
                  {country.name}
                </div>
              </motion.div>
            ))}
          </div>

          {/* Additional Markets Note */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.7 }}
            className="text-center mb-12"
          >
            <p className="text-gray-600 text-sm font-light">
              Plus selected international markets
            </p>
          </motion.div>
        </motion.div>

        {/* Interview Guarantee Info */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.8 }}
          className="bg-white p-8 rounded-lg border border-gray-200"
        >
          <div className="max-w-3xl mx-auto">
            <h3 className="text-lg font-semibold text-[#202356] mb-4 text-center">
              Guaranteed Interview Opportunities
            </h3>
            <p className="text-gray-600 text-sm font-light leading-relaxed text-center">
              Through these partnerships, eligible candidates may be offered guaranteed interview slots, subject to meeting role and employer criteria. Interview availability depends on employer demand and candidate readiness.
            </p>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default EmployerPartnerships;
